import { createContext, Dispatch, SetStateAction } from "react";
import { QueryClient } from "react-query/types/core/queryClient";
import { IAuthCallResponse } from "src/types/CommonTypes";

export interface IPolarionContextValue {
  session: IAuthCallResponse | undefined;
  setSession: (value: IAuthCallResponse | undefined) => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
  isAuthenticating: boolean;
  isPolarionX: boolean;
  setIsPolarionX: (value: boolean) => void;
  logout: () => void;
  login: () => Promise<void>;
  setLogin: (polarionCode: IAuthCallResponse) => Promise<void>;
  siteDisplay: string;
}

// Define the full context value interface
export interface IPolarionTeamsContextValue {
  configuration: any;
  isLoginFromBot: boolean;
  userConfiguration: any;
  teamcenterLanguage: any;
  polarion: IPolarionContextValue;
  failure: {
    error:
      | {
          title: string;
          message: string;
          statusCode: number;
          correlationId: string;
        }
      | undefined;
    setError: Dispatch<
      SetStateAction<
        | {
            title: string;
            message: string;
            statusCode: number;
            correlationId: string;
          }
        | undefined
      >
    >;
  };
  queryClient: QueryClient;
  i18n: { [key: string]: string };
}

export const PolarionTeamsContext = createContext<IPolarionTeamsContextValue>(
  {} as IPolarionTeamsContextValue
);
